import { Spec } from '../core/proto/common.js';
import { ActionId } from '../core/proto_utils/action_id.js';
import { Player } from '../core/player.js';
import { t } from '../core/i18n/index.js';

import * as InputHelpers from '../core/components/input_helpers.js';

import {
	Rogue_Options_PoisonImbue as Poison,
} from '../core/proto/rogue.js';

// Configuration for spec-specific UI elements on the settings tab.
// These don't need to be in a separate file but it keeps things cleaner.

export const MainHandImbue = InputHelpers.makeSpecOptionsEnumIconInput<Spec.SpecRogue, Poison>({
	fieldName: 'mhImbue',
	numColumns: 1,
	values: [
		{ value: Poison.NoPoison, tooltip: t('rogue.noMainHandPoison') },
		{ actionId: ActionId.fromItemId(43233), value: Poison.DeadlyPoison },
		{ actionId: ActionId.fromItemId(43231), value: Poison.InstantPoison },
		{ actionId: ActionId.fromItemId(43235), value: Poison.WoundPoison },
	],
});

export const OffHandImbue = InputHelpers.makeSpecOptionsEnumIconInput<Spec.SpecRogue, Poison>({
	fieldName: 'ohImbue',
	numColumns: 1,
	values: [
		{ value: Poison.NoPoison, tooltip: t('rogue.noOffHandPoison') },
		{ actionId: ActionId.fromItemId(43233), value: Poison.DeadlyPoison },
		{ actionId: ActionId.fromItemId(43231), value: Poison.InstantPoison },
		{ actionId: ActionId.fromItemId(43235), value: Poison.WoundPoison },
	],
});

export const StartingOverkillDuration = InputHelpers.makeSpecOptionsNumberInput<Spec.SpecRogue>({
	fieldName: 'startingOverkillDuration',
	label: t('rogue.startingOverkillDuration'),
	labelTooltip: t('rogue.startingOverkillDurationTooltip'),
	showWhen: (player: Player<Spec.SpecRogue>) => player.getTalents().overkill || player.getTalents().masterOfSubtlety > 0
});

export const VanishBreakTime = InputHelpers.makeSpecOptionsNumberInput<Spec.SpecRogue>({
	fieldName: 'vanishBreakTime',
	label: t('rogue.vanishBreakTime'),
	labelTooltip: t('rogue.vanishBreakTimeTooltip'),
	extraCssClasses: ['experimental'],
	showWhen: (player: Player<Spec.SpecRogue>) => player.getTalents().overkill || player.getTalents().masterOfSubtlety > 0
})

export const AssumeBleedActive = InputHelpers.makeSpecOptionsBooleanInput<Spec.SpecRogue>({
	fieldName: 'assumeBleedActive',
	label: t('rogue.assumeBleedActive'),
	labelTooltip: t('rogue.assumeBleedActiveTooltip'),
	extraCssClasses: ['within-raid-sim-hide'],
	showWhen: (player: Player<Spec.SpecRogue>) => player.getTalents().hungerForBlood
})

export const HonorOfThievesCritRate = InputHelpers.makeSpecOptionsNumberInput<Spec.SpecRogue>({
	fieldName: 'honorOfThievesCritRate',
	label: t('rogue.honorOfThievesCritRate'),
	labelTooltip: t('rogue.honorOfThievesCritRateTooltip'),
	showWhen: (player: Player<Spec.SpecRogue>) => player.getTalents().honorAmongThieves > 0
});

export const ApplyPoisonsManually = InputHelpers.makeSpecOptionsBooleanInput<Spec.SpecRogue>({
	fieldName: 'applyPoisonsManually',
	label: t('rogue.applyPoisonsManually'),
	labelTooltip: t('rogue.applyPoisonsManuallyTooltip'),
});

export const PrecombatRedirect = InputHelpers.makeSpecOptionsBooleanInput<Spec.SpecRogue>({
	fieldName: 'precombatRedirect',
	label: t('rogue.precombatRedirect'),
	labelTooltip: t('rogue.precombatRedirectTooltip'),
});

export const PrecombatHonorOfThieves = InputHelpers.makeSpecOptionsBooleanInput<Spec.SpecRogue>({
	fieldName: 'precombatHonorOfThieves',
	label: t('rogue.precombatHonorOfThieves'),
	labelTooltip: t('rogue.precombatHonorOfThievesTooltip'),
	showWhen: (player: Player<Spec.SpecRogue>) => player.getTalents().honorAmongThieves > 0
});
